import React from "react"
export function RadioButtonOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__radio-button---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
